/**
 * Typed client for /admin-rewards/* — backs the Reward Caps screen.
 *
 * These are the abuse ceilings for ACTION-based point awards (POST
 * /rewards/award on nurev-api). They live in AppConfig(type:'REWARD_LIMITS')
 * and are editable here without a deploy. The monitor payload is derived from
 * PointAward so an admin can spot farming (users maxing the daily cap).
 */
import { client, unwrap } from './client';

export interface RewardLimits {
  maxSingleAward: number;
  dailyActionPointCap: number;
}

export interface TopAwardee {
  publisherId: string;
  publisherUserId: string;
  pointsToday: number;
}

export interface RewardCapsMonitor {
  windowHours: number;
  totalActionPointsAwarded: number;
  awardCount: number;
  distinctUsers: number;
  usersAtDailyCapToday: number;
  topAwardeesToday: TopAwardee[];
}

export interface RewardCapsData {
  limits: RewardLimits;
  monitor: RewardCapsMonitor;
}

export function fetchRewardCaps(): Promise<RewardCapsData> {
  return unwrap(client.get('/admin-rewards/limits'));
}

export function updateRewardCaps(
  body: Partial<RewardLimits>
): Promise<{ limits: RewardLimits }> {
  return unwrap(client.patch('/admin-rewards/limits', body));
}
